<div>
  @if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    @for (question of questions; track question) {
    <div>
      @if (!['radio', 'checkbox'].includes(question.type)) {
      <wp-form-question [question]="question" [form]="form"></wp-form-question>
      } @else {
      <wp-form-group [question]="question" [form]="form"></wp-form-group>
      }
    </div>
    }
    <div [class]="'d-flex form ' + submitClasses">
      <wpbutton type="submit" (click)="onSubmit()" disableRoute="true">
        {{ submitText }} 
        @if (isProcessing) {
          <icon icon="refresh" class="-refresh -infinite-spin -sm15"></icon>
        }
      </wpbutton>
    </div>
  </form>
  }
</div>

<!-- <div class="wpdh-feedback-form__form-wrapper margin-reset-children text-center"
[@successState]="successState">
<button class="wpdh-feedback-form__close-button" (click)="closeSuccess()">Close</button>
<div class="wpdh-feedback-form__status-icon wpdh-feedback-form__status-icon--success"></div>
<h3>Thank you for your submission!</h3>
</div> -->
<!-- <div class="wpdh-feedback-form__form-wrapper margin-reset-children text-center"
[@failureState]="failureState">
<button class="wpdh-feedback-form__close-button" (click)="closeError()">Close</button>
<div class="wpdh-feedback-form__status-icon wpdh-feedback-form__status-icon--failure"></div>
<h3>Error! Something went wrong</h3>
</div> -->
